import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProfileService } from '../../../app/core/services/profile/profile.service';
@Injectable()
export class MenuItems {

  leftMenu = [
    {
      "roles": ["Buyer"],
      "state": "rfq",
      "name": "RFQs",
      "hasChildren": true,
      "icon": "ti-write",
      "children": [
        {
          "state": "buyer",
          "name": "Create an RFQ",
          "roles": ["Buyer"]
        },
        {
          "state": "draftrfqs",
          "name": "Draft RFQs",
          "roles": ["Buyer"]
        },
        {
          "state": "draftrfqs-ai",
          "name": "(AI) Draft RFQs",
          "roles": ["Buyer"],
          "featureFlag": "buyer_experience_ai"
        },
        {
          "state": "myrfq",
          "name": "RFQs",
          "roles": ["Buyer"]
        },
        {
          "state": "mycompanyrfq",
          "name": "Company RFQs",
          "roles": ["Buyer"]
        },
        {
          "state": "myquotes-v2",
          "name": "Quotes",
          "roles": ["Buyer"]
        },
        {
          "state": "markforquoting",
          "name": "Marked For Quoting",
          "roles": ["Buyer"]
        },
        {
          "state": "myorders",
          "name": "Orders",
          "roles": ["Buyer"]
        },
        {
          "state": "rfqnda",
          "name": "NDAs",
          "roles": ["Buyer"],
          "tooltip": "NDA Receipt Download\nYou can now download proof that suppliers accepted your NDA.",
          "showNewBadge": true
        }
      ]
    },
    {
      "roles": ["Supplier"],
      "accountType": ["Platinum", "Basic", "Starter", "Growth Package", "Gold"],
      "state": "supplier",
      "name": "Opportunities",
      "hasChildren": true,
      "icon": "ti-write no-css-opportunity",
      "children": [
        {
          "state": "supplierMyRfq",
          "name": "MFG RFQ Marketplace",
          "roles": ["Supplier"],
          "accountType": ["Professional", "Platinum", "Basic", "Starter", "Growth Package", "Gold"]
        },
        {
          "state": "privaterfq",
          "name": "Private RFQs",
          "icon": "no-css-private-rfq",
          "tooltip": "Create, quote and manage RFQs you receive directly from your buyers outside of the MFG Marketplace",
          "roles": ["Supplier"],
          "accountType": ["Professional", "Platinum", "Gold"]
        }
      ]
    },

    {
      "state": "supplier",
      "name": "Quotes",
      "hasChildren": true,
      "icon": "icon_quotes",
      "roles": ["Supplier"],
      "accountType": ["Platinum", "Basic", "Starter", "Growth Package", "Gold"],

      "children": [
        {
          "state": "myQuotes",
          "name": "Quotes",
          "roles": ["Supplier"],
          "accountType": ["Platinum", "Basic", "Starter", "Growth Package", "Gold"]
        },
        {
          "state": "myunlockedrfq",
          "name": "Unlocked RFQs",
          "accountType": ["Platinum", "Basic", "Starter", "Growth Package", "Gold"],
          title: "mnu_unlocked_rfqs",
        },
        {
          "state": "myCompanyQuotes",
          "name": "Company Quotes",
          "roles": ["Supplier"],
          "accountType": ["Platinum", "Basic", "Starter", "Growth Package", "Gold"]
        },
        {
          "state": "quotesinprogress",
          "name": "Quotes In Progress",
          "roles": ["Supplier"],
          "accountType": ["Platinum", "Basic", "Starter", "Growth Package", "Gold"]
        },
      ]
    },
    {
      "state": "rfq/myorders",
      "name": "Orders",
      "hasChildren": false,
      "icon": "icon_orders",
      "roles": ["Supplier"],
      "accountType": ["Platinum", "Basic", "Starter", "Growth Package", "Gold"]
    },
    {
      "roles": ["Buyer"],
      "state": "partlibrary",
      "name": "Parts",
      "hasChildren": false,
      "icon": "ti-hummer"
    },
    {
      "roles": ["Buyer"],
      "state": "buyerContact",
      "name": "Contact List",
      "hasChildren": false,
      "icon": "ti-agenda"
    },
    {
      "roles": ["Buyer"],
      "state": "supplierviews",
      "name": "Profile Views",
      "hasChildren": false,
      "icon": "ti-wand"
    },
    {
      "roles": ["Buyer"],
      "state": "chat",
      "name": "Chat",
      "hasChildren": false,
      "icon": "ti-comment-alt"
    },
    {
      "roles": ["Supplier"],
      "accountType": ["Platinum", "Basic", "Starter", "Growth Package", "Gold"],
      "state": "followedbuyercontact",
      "name": "Contacts",
      "hasChildren": false,
      "icon": "ti-agenda"
    },
    {
      "roles": ["Supplier"],
      "accountType": ["Platinum", "Basic", "Starter", "Growth Package", "Gold"],
      "state": "chat",
      "name": "Chat",
      "hasChildren": false,
      "icon": "ti-comment-alt"
    },
    {
      "roles": ["Supplier"],
      "accountType": ["Professional", "Starter", "Growth Package", "Gold", "Platinum"],
      "state": "materialMenu",
      "name": "Source Materials",
      "hasChildren": true,
      "icon": "icon_getmaterial",
      "children": [
        {
          "state": "materialNewQuoteRequest",
          "name": "New Quote Request",
          "roles": ["Supplier"],
          "accountType": ["Professional", "Starter", "Growth Package", "Gold", "Platinum"]
        },
        {
          "state": "materialOpenRequest",
          "name": "Open Request",
          "roles": ["Supplier"],
          "accountType": ["Professional", "Starter", "Growth Package", "Gold", "Platinum"]
        },
        {
          "state": "materialClosedRequest",
          "name": "Closed request",
          "roles": ["Supplier"],
          "accountType": ["Professional", "Starter", "Growth Package", "Gold", "Platinum"]
        },
        {
          "state": "materialOrders",
          "name": "Orders",
          "roles": ["Supplier"],
          "accountType": ["Professional", "Starter", "Growth Package", "Gold", "Platinum"]
        }
      ]
    },

    {
      "roles": ["Supplier", "Buyer"],
      "accountType": ["Platinum", "Basic", "Starter", "Growth Package", "Gold"],
      "state": "globalMessage",
      "name": "Messages",
      "hasChildren": false,
      "icon": "ti-email"
    },
    {
      "roles": ["Supplier", "Buyer"],
      "accountType": ["Professional", "Platinum", "Basic", "Starter", "Growth Package", "Gold"],
      "state": "globalNotification",
      "name": "Notifications",
      "hasChildren": false,
      "icon": "ti-bell"
    }
  ]

  constructor(private profileService: ProfileService) {

  }
  getAllLeftMenuItem(inputData): Observable<any> {
    return new Observable<any>(observer => {

      if (inputData.userType == "Supplier") {
        this.profileService.getProfessionalPackageDetail(parseInt(AppStorageUtil.getItem("loggedCompanyId"))).subscribe(
          data => {
            AppStorageUtil.setItem("isProfessionalPackage", data.isFound);
            if (data.isFound) {
              inputData.accountType = "Professional";
            }
            return this.applyMoreFilters(inputData, observer);
          }
        )
      } else {
        this.profileService.getConfigCatBuyerAiData().subscribe(
          isBuyerAiEnabled => {
            inputData.isBuyerAiEnabled = isBuyerAiEnabled;
            return this.applyMoreFilters(inputData, observer);
          }
        );
      }
    });
  }
  applyMoreFilters(inputData, observer) {
    let leftMenu: any = this.leftMenu;
    leftMenu = leftMenu.filter(item => {
      return item.roles.indexOf(inputData.userType) > -1;
    });
    if (!inputData.isBuyerAiEnabled) {
      leftMenu = leftMenu.map(item => {
        if (item.hasChildren && item.children) {
          item = { ...item, children: item.children.filter(child => !child.featureFlag || child.featureFlag !== 'buyer_experience_ai') };
        }
        return item;
      });
    } else {
      // Flag ON: redirect "Create an RFQ" to the widget route; "(AI) Create RFQ" is already removed from the menu definition
      leftMenu = leftMenu.map(item => {
        if (item.hasChildren && item.children) {
          const children = item.children.map(child =>
            child.state === 'buyer' && child.name === 'Create an RFQ'
              ? { ...child, state: 'rfq-ai' }
              : child
          );
          item = { ...item, children };
        }
        return item;
      });
    }
    if (inputData.userType == "Supplier") {

      leftMenu = leftMenu.filter(item => {
        if (item.hasChildren) {
          item.children = item.children.filter(child => {
            if (child.accountType) {
              return (child.accountType.indexOf(inputData.accountType) > -1);
            }
            return true;
          });
        }
        return (item.accountType.indexOf(inputData.accountType) > -1)
      });

      if (!inputData.showMfgContactRfqLeftMenu) {
        const menuIndex = this.leftMenu.findIndex(menu => {
          return menu.hasChildren && menu.children.some(item =>
            item.state === "mfgcontact"
          )
        }
        );
        if (menuIndex !== -1) {
          leftMenu[menuIndex].main.shift();
        }
      }
      if (inputData.unlockedRfq == 0) {
        leftMenu.filter(moduleNameObj => {
          if (moduleNameObj.hasChildren) {
            moduleNameObj.children = moduleNameObj.children.filter(child => {
              return child.state != "myunlockedrfq"
            });
          }
          return true;
        });
      }
      if (inputData.userLocation != "US") {
        leftMenu = leftMenu.filter(moduleNameObj => moduleNameObj.state != "materialMenu");
      }
    }
    observer.next({ leftMenu: leftMenu, isProfessionalPackage: false });
    observer.complete();
  }
}
